import { render, staticRenderFns } from "./web-href.vue?vue&type=template&id=a13c2cae&scoped=true"
import script from "./web-href.vue?vue&type=script&lang=js"
export * from "./web-href.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13c2cae",
  null
  
)

export default component.exports